import React, { createContext, useContext, useMemo } from 'react';

import type { FileSummary } from '@savgroup-front-common/types';

export interface DossierFileInfoContextValue {
  fileId: string;
  file: FileSummary;
}

const DossierFileInfoContext = createContext<DossierFileInfoContextValue | null>(null);

interface DossierFileInfoProviderProps {
  fileId: string;
  claimId: string;
  children: React.ReactNode;
}

export const DossierFileInfoProvider = ({
  fileId,
  claimId,
  children,
}: DossierFileInfoProviderProps) => {
  const value = useMemo<DossierFileInfoContextValue>(
    () => ({
      fileId,
      file: {
        claimInfoSummary: {
          claimId,
        },
      } as FileSummary,
    }),
    [claimId, fileId],
  );

  return (
    <DossierFileInfoContext.Provider value={value}>{children}</DossierFileInfoContext.Provider>
  );
};

export const useDossierFileInfoContext = (): DossierFileInfoContextValue => {
  const context = useContext(DossierFileInfoContext);

  if (!context) {
    throw new Error('useDossierFileInfoContext doit être utilisé sous DossierFileInfoProvider');
  }

  return context;
};
